import { AxiosPrivate } from '../../utils';

class AssetsApi {
  private static instance: AssetsApi;

  public static getInstance(): AssetsApi {
    if (!AssetsApi.instance) {
      AssetsApi.instance = new AssetsApi();
    }
    return AssetsApi.instance;
  }

  getAsset = (linkToFile: string) => {
    return AxiosPrivate({
      url: `${process.env.REACT_APP_API_URL + linkToFile}`,
      method: 'GET',
      responseType: 'blob',
    });
  };
}

export const assetsApi = AssetsApi.getInstance();
